import { IClientValidator } from "./IClientValidator.js";

    /// Works with CompareCaseInsensitiveAttribute.cs to perform unobtrusive validation in MVC against

    /// input elements where case does not matter, such as inputs for verifying email addresses.
    export class CompareCaseInsensitive implements IClientValidator {
        public validate(value: string, element: HTMLInputElement, params: any): boolean {
            let otherObj = document.querySelector<HTMLInputElement>(`input[name="${params.otherproperty}"]`);

            return element.value.toLowerCase() === otherObj.value.toLowerCase();
        }
    }

window.validators = window.validators || {};
window.validators.comparecaseinsensitive = new CompareCaseInsensitive();
